import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  ChangeDetectionStrategy
} from '@angular/core';
import { LetterOnBoard } from '@schoolbelle/api/letter-to-board';
import { calculateDaysLeft } from '@schoolbelle/shared/pipes';

@Component({
  selector: 'app-letter-tags',
  templateUrl: './letter-tags.component.html',
  styleUrls: ['./letter-tags.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LetterTagsComponent implements OnInit {
  @Input() item: LetterOnBoard;
  @Input('fixedAtTop') isFixedAtTop: boolean = false;
  now: number;
  reserved: boolean;
  hasSurvey: boolean;
  hasSumit: boolean;

  deadline: number;
  daysleft: number;
  answered: boolean;
  mailmerge: boolean;
  fixedAtTop: number;

  constructor(protected cdRef: ChangeDetectorRef) {}

  ngOnInit() {}
  ngOnChanges() {
    this.refresh();
  }

  refresh() {
    this.now = Date.now();
    this.reserved = this.item.issue_at ? true : false;
    this.hasSurvey =
      (this.item.survey_id_g3 &&
        this.item.survey_id_g3.split(':')[0] !== 'submit') ||
      this.item.survey_id ||
      this.item.questionnaire_id
        ? true
        : false;
    this.hasSumit =
      this.item.survey_id_g3 &&
      this.item.survey_id_g3.split(':')[0] === 'submit'
        ? true
        : false;

    if (this.hasSurvey) {
      this.deadline = this.item.deadline;
      if (this.deadline && this.deadline < Date.now()) this.daysleft = -1;
      else
        this.daysleft = this.deadline
          ? calculateDaysLeft(this.deadline)
          : Infinity;
      this.answered = this.item.replies && this.item.replies.length > 0;
    }
    // original
    if (this.isFixedAtTop === true && this.item.fixed_for)
      this.fixedAtTop =
        this.item.fixed_for + this.item.letter_created_at > this.now
          ? this.item.fixed_for + this.item.letter_created_at
          : null;
    // console.log(this.item, this.fixedAtTop, this.item.fixed_for, new Date(this.item.letter_created_at), new Date(this.item.fixed_for + this.item.letter_created_at));
  }
}
